export default __webpack_public_path__ + "marker-800-6b0bd28ea59a5ad4404b5b3b625f07de.png";